import { Component, computed, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '@/app/core/services/theme/theme.service';

@Component({
  selector: 'app-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class EmptyStateComponent {
  private themeService = inject(ThemeService);
  protected themeContent = this.themeService.themeContent;
  protected emptyStateContent = computed(() => this.themeContent()?.shared.emptyStateComponent);

  @Input() message?: string;

  protected displayMessage = computed(() => {
    if (this.message) return this.message;
    return this.emptyStateContent()?.title || 'No hay suficientes datos para generar el reporte.';
  });
}
